// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--1VM-H","textWrapper":"index-module--textWrapper--2C000","close":"index-module--close--8t0g6"};